import Task from "../task";
import {ACLRole} from "../../../gd/access-control/user-roles";


export function taskCheckRole(task:Task, role: ACLRole):boolean {

    if (!task) {
        return false
    }

    switch (role) {
        case ACLRole.TASK_CREATOR:
            return task.createdByUserId === gd.user.id || task.createdOnBehalfByUserId === gd.user.id



        // Generic from comapny
        case ACLRole.COMPANY_MANAGER:
            return gd.ac.check.company.isManager()

    }

    console.error("#93834 not meant to be here")

    return true

}